// Site option code that grants access to the Coaching integration.
// Must match the `permission` used for this entry in Core/containers/Sidebar MENUS.
export const COACH_SSO_PERMISSION = 'coachsso';

// TanStack Query key for the coaching SSO token.
export const COACHING_TOKEN_QUERY_KEY = ['integrations', 'coachSSO', 'token'];

// TanStack Query key for the Coaching host reachability check.
export const COACHING_REACHABILITY_QUERY_KEY = ['integrations', 'coachSSO', 'reachability'];

export const COACHING_IFRAME_ID = 'coachSSO';

// Key that prefixes every log line of the module (`Core/logManager`, console + DataDog when
// initialized), so the entries can be filtered as `coachSSO <event>`. The token is never logged.
export const COACH_SSO_LOG_KEY = 'coachSSO';

// `eventType` of the postMessage sent to the Coaching iframe when a tab is selected.
export const NAVIGATION_EVENT_TYPE = 'navigation';

// Query param that carries the active tab in the Cloud React URL (`/app/coaching?tab=trips`).
export const TAB_QUERY_PARAM = 'tab';

// localStorage key holding the last tab the user visited; restored when the URL has no `?tab=`.
export const LAST_TAB_STORAGE_KEY = 'coachSSO_lastTab';

// Sub-user roles of the Coaching integration: management.modules `userCode` of the `coachsso_admin`,
// `coachsso_manager` and `coachsso_coach` permissions the Roles module assigns (one per role). They
// arrive in `user.options` and are checked through `Core/security` `HasPermission`, like the Sidebar.
export const COACHING_ROLE_CODES = { admin: 376, manager: 377, coach: 378 };
const { admin, manager, coach } = COACHING_ROLE_CODES;
const EVERY_ROLE = [admin, manager, coach];

// Must match the `subuser` list of the `coach-sso` entry in Core/containers/Sidebar MENUS.
export const COACHING_ROLE_USER_CODES = EVERY_ROLE;

// Header tabs. `path` is both the value sent to the Coaching app and the `?tab=` value.
// `subuser` lists the roles that may open the tab (same meaning as `subuser` in the Sidebar MENUS;
// the main account always may). The first entry is the default tab (the Coaching app opens on it by
// itself) and must stay open to every role.
export const COACHING_TABS = [
  { id: 'home', path: 'home', labelKey: 'coachSSO_tab_home', subuser: EVERY_ROLE },
  { id: 'safetyEvents', path: 'safety-events', labelKey: 'coachSSO_tab_safetyEvents', subuser: EVERY_ROLE },
  { id: 'trips', path: 'trips', labelKey: 'coachSSO_tab_trips', subuser: EVERY_ROLE },
  { id: 'liveView', path: 'live-view', labelKey: 'coachSSO_tab_liveView', subuser: [admin, manager] },
  { id: 'coaching', path: 'coaching', labelKey: 'coachSSO_tab_coaching', subuser: [admin, coach] },
  { id: 'videoRequests', path: 'video-requests', labelKey: 'coachSSO_tab_videoRequests', subuser: [admin, manager] },
  { id: 'challenges', path: 'challenges', labelKey: 'coachSSO_tab_challenges', subuser: [admin, coach] },
  { id: 'reports', path: 'reports', labelKey: 'coachSSO_tab_reports', subuser: [admin, manager] },
  { id: 'configurations', path: 'configurations', labelKey: 'coachSSO_tab_configurations', subuser: [admin, manager] },
];

export const DEFAULT_COACHING_TAB = COACHING_TABS[0];
